import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseUrl, onPrepareHeaders } from "@/redux/services/helpers";

/**
 * Loan RTK Query service — thin createApi shell.
 * Endpoints are injected from individual files in ./endpoints/.
 */
export const loanService = createApi({
  reducerPath: "loanApi",
  tagTypes: ["Loan", "Kanban", "LoanLendersHeatMap"],
  baseQuery: fetchBaseQuery({ baseUrl, prepareHeaders: onPrepareHeaders }),
  endpoints: () => ({}),
});

